var toString = {}.toString;

module.exports = Array.isArray || function (arr) {
  return toString.call(arr) == '[object Array]';
};



// WEBPACK FOOTER //
// C:/Dropbox/www/amcharts4dev/node_modules/isarray/index.js